module.exports = __webpack_public_path__ + "img/announce.63b75ad3.svg";